import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogueApiService, SearchCriteria } from '@angular-workspace/services';

export interface StatItem {
  icon: string;
  number: string;
  label: string;
  apiType?: string; // Store the API type for mapping
}

@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.scss',
})
export class StatisticsComponent implements OnInit {
  stats: StatItem[] = [
    {
      icon: '/asset-dataBank.svg',
      number: '0',
      label: 'Datasets',
      apiType: 'adex:DataBank'
    },
    {
      icon: '/asset-ai-model.svg',
      number: '0',
      label: 'Models',
      apiType: 'adex:AiModel'
    },
    {
      icon: '/asset-use-case.svg',
      number: '11',
      label: 'Usecases'
    },
    {
      icon: '/leaf.svg',
      number: '5',
      label: 'Concepts'
    }
  ];

  constructor(private catalogueApiService: CatalogueApiService) {}

  ngOnInit(): void {
    this.loadStatistics();
  }

  async loadStatistics(): Promise<void> {
    try {
      // Build search criteria for DataBank, AiModel, and Apps
      const searchCriteria: SearchCriteria[] = [
        {
          searchType: 'term',
          field: 'type',
          values: ['adex:DataBank', 'adex:AiModel', 'adex:Apps']
        }
      ];

      const response = await this.catalogueApiService.getCount(searchCriteria);

      // Extract the count data from the response
      if (response?.result && response.result.length > 0) {
        const countData = response.result[0];

        // Update stats with API response
        this.stats.forEach(stat => {
          if (stat.apiType && countData[stat.apiType] !== undefined) {
            stat.number = countData[stat.apiType].toString();
          }
        });
      }
    } catch (error) {
      // Error is already handled by NetworkService (toaster shown)
      // Keep default values (0) on error
      console.error('Failed to load statistics:', error);
    }
  }
}

